/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Metrics_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Event metrics" |
*
* @param {Event_Metrics_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_aria_label = /** @type {((inputs?: Event_Metrics_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Metriques de l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignismetriken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metriche degli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метрики событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Métricas de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件指标")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントメトリクス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट मेट्रिक्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Métricas do evento")
	return /** @type {LocalizedString} */ ("Event metrics")
});